import { LoadingOutlined } from "@ant-design/icons";
import React from "react";

const LoadingIcon = (props) => (
  <LoadingOutlined style={{ fontSize: "12px", marginLeft: "8px" }} {...props} />
);

export default LoadingIcon;
